import React, { useState } from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text4 } from "../../../styles";
import { Button, Icon, Tooltip, Spin } from "antd";
import './index.scss';
import { handleApiExceptions, printRupee } from "../../../app_methods";
import { MerchantService } from "../../../services";
import { LoadAccountModal } from "./load_amount_modal";
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { CreateAccountModal } from '../../Common';
import { EaseTable } from "../../../libs/EaseTable";
import { Merchant } from "../../../models";
import { PermissionHoc } from "../../HOC";

const AllotedAccountWriteIcon = PermissionHoc(Icon, "ALLOTED_ACCOUNT_WRITE", { is_component: true, fallbackComponent: null })
const AllotedAccountWriteButton = PermissionHoc(Button, "ALLOTED_ACCOUNT_WRITE", { is_component: true, fallbackComponent: null })


const AllotedConnectedBankingDrawer = (props) => {
    const { merchant } = props;
    const [shared_connected_banking_accounts, setshared_connected_banking_accounts] = useState([])
    const [showAmountLoadModal, setShowAmountLoadModal] = useState(false)
    const [fetchingBalance, setFetchingBalance] = useState('')
    const [showCreateAccountModal, setShowCreateAccountModal] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('')
    const [isfetchingAccounts, setFetchingAccounts] = useState(true)

    const toggleAmountLoadModal = (account) => {
        setSelectedAccount(account)
        setShowAmountLoadModal(!showAmountLoadModal);
    };

    const toggleCreateAccountModal = () => {
        setShowCreateAccountModal(!showCreateAccountModal)
    }

    const fetchBlance = async (recordId) => {
        setFetchingBalance(recordId);
        const response = await MerchantService.get_balance({ id: recordId });
        if (!response.success) {
            handleApiExceptions(response);
            setFetchingBalance('');
            return;
        }
        let vas = shared_connected_banking_accounts
        vas.map((ac) => ((ac.id == recordId) ? ac.balance = response.data.balance : ac))
        setshared_connected_banking_accounts([...vas])
        setFetchingBalance('');

    };

    const fetchAllotedAccounts = async () => {
        setFetchingAccounts(true);
        const response = await Merchant.get_alloted_accounts(merchant.id);
        if (!response.success) {
            handleApiExceptions(response);
            setFetchingAccounts(false);
            return;
        }
        let vas = response.data.virtual_accounts
        setshared_connected_banking_accounts([...vas])
        setFetchingAccounts(false);
    }

    const columns = [
        {
            title: 'Account Number',
            key: 'virtual_account_number',
            render: (record) => <>
            <div><Text4>{record.parent_account_number}</Text4></div>
            <div><Text4 type='secondary'>{record.label}</Text4></div>
            </>
        },
        {
            title: 'Balance',
            key: 'balance',
            render: (record) => <div>{printRupee(record.balance) || "---"}
            </div>
        },
        {
            title: 'Actions',
            key: 'action',
            render: (record) => <div>
                <span className="justify-content-centre">
                    <Tooltip title="Get Updated Balance">
                        <Icon
                            className="mr-3"
                            type="sync"
                            spin={record.id == fetchingBalance}
                            onClick={() => { (record.id != fetchingBalance) && fetchBlance(record.id) }}
                        />
                    </Tooltip>
                    <Tooltip title="Manage funds">
                        <AllotedAccountWriteIcon
                            className="mr-3"
                            type="bank"
                            onClick={() => toggleAmountLoadModal(record)}
                        />
                    </Tooltip>
                </span>
            </div>
        },

    ];

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Allotted Accounts</Text1>
            </div>
        )
    };


    const renderSharedAccountBankDetails = () => {
        return (
            <>
                <div className="d-flex justify-content-end">
                    <AllotedAccountWriteButton size="small" className='float-right' onClick={toggleCreateAccountModal}>Create Account</AllotedAccountWriteButton>
                </div>
                <EaseTable
                    className="border-top border-left border-right rounded"
                    columns={columns}
                    data={shared_connected_banking_accounts}
                    size="middle"
                    pagination={false}
                />
            </>
        )
    }

    return (
        <EaseDrawer
            className="merchant-details-wrapper"
            title={false}
            width={550}
            visible={props.visible}
            onOpen={() => fetchAllotedAccounts()}
            onClose={props.toggleAllotedConnectedBankingDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <>{isfetchingAccounts ?
                <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                    <Spin className="mt-2" tip="Loading..." spinning={isfetchingAccounts} />
                </div> :
                <div className="mt-3">
                    {renderTitle()}
                    {renderSharedAccountBankDetails()}
                </div>
            }

            </>

            <LoadAccountModal
                visible={showAmountLoadModal}
                merchant={merchant}
                toggleAmountLoadModal={toggleAmountLoadModal}
                toggleDetailsDrawer={props.toggleDetailsDrawer}
                account={selectedAccount}
                fetchBlance={fetchBlance}
            />
            <CreateAccountModal
                visible={showCreateAccountModal}
                toggleCreateAccountModal={toggleCreateAccountModal}
                merchant={merchant}
                fetchAllotedAccounts={fetchAllotedAccounts}
            />

        </EaseDrawer>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(AllotedConnectedBankingDrawer);